import { TypePromotions } from "~/types/promotions";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const abortStore = useAbortControllerStore()
    abortStore.abortAllExceptLast()
    // const config = useRuntimeConfig()
    // const laravel_session = useCookie('laravel_session')

    // const finalUrl = config.public.TIODOMIN_API_BASE_URL + '/start-session'

    // const c = await $fetch.raw(finalUrl, {method: 'POST'})
    // laravel_session.value = c.headers.getSetCookie()[0]
    // console.log(laravel_session.value, 'laravel_session')
    const queryParams = to.query;
    const refererId = queryParams.referer_id
    const typo = queryParams.type_promotion
    const category = queryParams.category ?? null
    const product = to.params.product
    const promotion = queryParams.promotion
    
    if (typo) {
        
        const promotions = localStorage.getItem('promotions')
        const objPromotions2Insert = {
            promotion,
            type_promotion_id: typo?.toString(),
            "referer_id": refererId,
            category,
            product
        }
        if (promotions) {
            const arrayOfPromotions = JSON.parse(promotions) as Array<{
                promotion: any
                type_promotion_id: string|number,
                "referer_id": any,
                category: any,
                product: any
            }>
            console.log(arrayOfPromotions, 'arrayOfPromotions')
            //already exists
            const exists = arrayOfPromotions.some(p => 
                p.promotion === objPromotions2Insert.promotion
            )
            if(!exists){
                arrayOfPromotions.push(objPromotions2Insert)
                localStorage.setItem('promotions',JSON.stringify(arrayOfPromotions))
            }
            
        } else {
            console.log("add promotions", 'globalIndexOfTypePromotions')
            localStorage.setItem('promotions', JSON.stringify([objPromotions2Insert]))
        }

    }

})
